import {
  FETCH_REWARDS_REQUEST,
  FETCH_REWARDS_SUCCESS,
  FETCH_REWARDS_FAILURE,
  UPDATE_REWARDS_REQUEST,
  UPDATE_REWARDS_SUCCESS,
  UPDATE_REWARDS_FAILURE,
} from "../../actionTypes/reward";
import { RewardsService } from "../../../../api/RewardsService";
import { CognitoUser } from "amazon-cognito-identity-js";
import { RewardsPayload } from "../../../../../types/db-types";

interface FetchRewardsRequestAction {
  type: typeof FETCH_REWARDS_REQUEST;
}

interface FetchRewardsSuccessAction {
  type: typeof FETCH_REWARDS_SUCCESS;
  payload: RewardsPayload;
}

interface FetchRewardsFailureAction {
  type: typeof FETCH_REWARDS_FAILURE;
  payload: any;
}

interface UpdateRewardsRequestAction {
  type: typeof UPDATE_REWARDS_REQUEST;
}

interface UpdateRewardsSuccessAction {
  type: typeof UPDATE_REWARDS_SUCCESS;
  payload: any;
}

interface UpdateRewardsFailureAction {
  type: typeof UPDATE_REWARDS_FAILURE;
  payload: any;
}

export const fetchRewardsRequest = (): FetchRewardsRequestAction => ({
  type: FETCH_REWARDS_REQUEST,
});

export const fetchRewardsSuccess = (data: RewardsPayload): FetchRewardsSuccessAction => ({
  type: FETCH_REWARDS_SUCCESS,
  payload: data,
});

export const fetchRewardsFailure = (error: any): FetchRewardsFailureAction => ({
  type: FETCH_REWARDS_FAILURE,
  payload: error,
});

export const updateRewardsRequest = (): UpdateRewardsRequestAction => ({
  type: UPDATE_REWARDS_REQUEST,
});

export const updateRewardsSuccess = (data: any): UpdateRewardsSuccessAction => ({
  type: UPDATE_REWARDS_SUCCESS,
  payload: data,
});

export const updateRewardsFailure = (error: any): UpdateRewardsFailureAction => ({
  type: UPDATE_REWARDS_FAILURE,
  payload: error,
});

export type RewardsActions =
  | FetchRewardsRequestAction
  | FetchRewardsSuccessAction
  | FetchRewardsFailureAction
  | UpdateRewardsRequestAction
  | UpdateRewardsSuccessAction
  | UpdateRewardsFailureAction;

interface FetchRewardsDataTypes {
  cognitoUser: CognitoUser;
  propertyId: any;
  accountingId: any;
  timeout?: number;
  timeoutEnabled?: boolean;
}
// action to fetch Rewards from the backend
export const fetchRewardsData = (data: FetchRewardsDataTypes): any => {
  const { cognitoUser, accountingId, propertyId, timeout = 8000, timeoutEnabled = true } = data;
  return async (dispatch: any) => {
    const rewardsApiService = new RewardsService(cognitoUser, dispatch);
    dispatch(fetchRewardsRequest());
    try {
      const apiCallData = { propertyId, accountingId };
      const response = timeoutEnabled
        ? await Promise.race([
            rewardsApiService.getRewardDetails(apiCallData),
            new Promise<Response>(
              (_, reject) => setTimeout(() => reject(new Error("Timeout")), timeout) // timeout
            ),
          ])
        : await rewardsApiService.getRewardDetails(apiCallData);
      const data = await response;
      dispatch(fetchRewardsSuccess(data));
    } catch (error: any) {
      dispatch(fetchRewardsFailure(error));
    }
  };
};

interface UpdateRewardActionDataTypes {
  cognitoUser: CognitoUser;
  propertyId: any;
  accountingId: any;
  ledgerItemId: any;
  body: any;
  timeout?: number;
  timeoutEnabled?: boolean;
}
// action to update Rewards
export const updateRewardAction = (data: UpdateRewardActionDataTypes): any => {
  const {
    cognitoUser,
    accountingId,
    propertyId,
    ledgerItemId,
    body,
    timeout = 8000,
    timeoutEnabled = false,
  } = data;
  return async (dispatch: any) => {
    const rewardsApiService = new RewardsService(cognitoUser, dispatch);
    dispatch(updateRewardsRequest());
    try {
      const apiCallData = { propertyId, accountingId, ledgerItemId, body };

      const response = timeoutEnabled
        ? await Promise.race([
            rewardsApiService.updateReward(apiCallData),
            new Promise<Response>(
              (_, reject) => setTimeout(() => reject(new Error("Timeout")), timeout) // timeout
            ),
          ])
        : await rewardsApiService.updateReward(apiCallData);
      const data = await response;
      await dispatch(fetchRewardsData({ cognitoUser, propertyId, accountingId }));
      return data; // Return the data from the API call
    } catch (error: any) {
      dispatch(updateRewardsFailure(error));
      throw error; // Rethrow the error so it can be caught by the caller
    }
  };
};
